// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/featurama/service.proto
/* eslint-disable */
import * as _m0 from "protobufjs/minimal.js";
import { Feature } from "../sub2/data.js";
import { ActivationStatus, FeatureSetKey, FeatureSetStatusForSeller } from "./feature_sets.js";
import { FeatureStatusForSeller } from "./model.js";
// For Node.js to access named exports from CommonJS
const __m0 = 'default' in _m0 ? _m0.default : _m0;
export const protobufPackage = "squareup.featurama.service";
function createBaseBulkRetrieveFeatureSetStatusesRequest() {
    return { $type: "squareup.featurama.service.BulkRetrieveFeatureSetStatusesRequest", featureSetKeys: [] };
}
export const BulkRetrieveFeatureSetStatusesRequest = {
    $type: "squareup.featurama.service.BulkRetrieveFeatureSetStatusesRequest",
    encode(message, writer = __m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.featureSetKeys) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBulkRetrieveFeatureSetStatusesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag === 8) {
                        message.featureSetKeys.push(reader.int32());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.featureSetKeys.push(reader.int32());
                        }
                        continue;
                    }
                    break;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BulkRetrieveFeatureSetStatusesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBulkRetrieveFeatureSetStatusesRequest();
        message.featureSetKeys = object.featureSetKeys?.map((e) => e) || [];
        return message;
    },
};
function createBaseBulkRetrieveFeatureStatusesRequest() {
    return {
        $type: "squareup.featurama.service.BulkRetrieveFeatureStatusesRequest",
        keys: [],
        includeSubscriptionMetadata: undefined,
        includeActivationStatuses: undefined,
        consistent: undefined,
    };
}
export const BulkRetrieveFeatureStatusesRequest = {
    $type: "squareup.featurama.service.BulkRetrieveFeatureStatusesRequest",
    encode(message, writer = __m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.keys) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.includeSubscriptionMetadata !== undefined) {
            BulkRetrieveFeatureStatusesRequest_IncludeSubscriptionMetadata.encode(message.includeSubscriptionMetadata, writer.uint32(18).fork()).ldelim();
        }
        if (message.includeActivationStatuses !== undefined) {
            writer.uint32(24).bool(message.includeActivationStatuses);
        }
        if (message.consistent !== undefined) {
            writer.uint32(32).bool(message.consistent);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBulkRetrieveFeatureStatusesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag === 8) {
                        message.keys.push(reader.int32());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.keys.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.includeSubscriptionMetadata = BulkRetrieveFeatureStatusesRequest_IncludeSubscriptionMetadata.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.includeActivationStatuses = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.consistent = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BulkRetrieveFeatureStatusesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBulkRetrieveFeatureStatusesRequest();
        message.keys = object.keys?.map((e) => e) || [];
        message.includeSubscriptionMetadata =
            (object.includeSubscriptionMetadata !== undefined && object.includeSubscriptionMetadata !== null)
                ? BulkRetrieveFeatureStatusesRequest_IncludeSubscriptionMetadata.fromPartial(object.includeSubscriptionMetadata)
                : undefined;
        message.includeActivationStatuses = object.includeActivationStatuses ?? undefined;
        message.consistent = object.consistent ?? undefined;
        return message;
    },
};
function createBaseBulkRetrieveFeatureStatusesRequest_IncludeSubscriptionMetadata() {
    return {
        $type: "squareup.featurama.service.BulkRetrieveFeatureStatusesRequest.IncludeSubscriptionMetadata",
        planGroupToken: undefined,
    };
}
export const BulkRetrieveFeatureStatusesRequest_IncludeSubscriptionMetadata = {
    $type: "squareup.featurama.service.BulkRetrieveFeatureStatusesRequest.IncludeSubscriptionMetadata",
    encode(message, writer = __m0.Writer.create()) {
        if (message.planGroupToken !== undefined) {
            writer.uint32(10).string(message.planGroupToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBulkRetrieveFeatureStatusesRequest_IncludeSubscriptionMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.planGroupToken = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BulkRetrieveFeatureStatusesRequest_IncludeSubscriptionMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBulkRetrieveFeatureStatusesRequest_IncludeSubscriptionMetadata();
        message.planGroupToken = object.planGroupToken ?? undefined;
        return message;
    },
};
function createBaseRetrieveFeatureSetStatusRequest() {
    return { $type: "squareup.featurama.service.RetrieveFeatureSetStatusRequest", featureSetKey: undefined };
}
export const RetrieveFeatureSetStatusRequest = {
    $type: "squareup.featurama.service.RetrieveFeatureSetStatusRequest",
    encode(message, writer = __m0.Writer.create()) {
        if (message.featureSetKey !== undefined) {
            writer.uint32(8).int32(message.featureSetKey);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRetrieveFeatureSetStatusRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.featureSetKey = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return RetrieveFeatureSetStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRetrieveFeatureSetStatusRequest();
        message.featureSetKey = object.featureSetKey ?? undefined;
        return message;
    },
};
function createBaseUpdateFeatureSetStatusRequest() {
    return {
        $type: "squareup.featurama.service.UpdateFeatureSetStatusRequest",
        featureSetKey: undefined,
        activationStatus: undefined,
    };
}
export const UpdateFeatureSetStatusRequest = {
    $type: "squareup.featurama.service.UpdateFeatureSetStatusRequest",
    encode(message, writer = __m0.Writer.create()) {
        if (message.featureSetKey !== undefined) {
            writer.uint32(8).int32(message.featureSetKey);
        }
        if (message.activationStatus !== undefined) {
            writer.uint32(16).int32(message.activationStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateFeatureSetStatusRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.featureSetKey = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.activationStatus = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return UpdateFeatureSetStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateFeatureSetStatusRequest();
        message.featureSetKey = object.featureSetKey ?? undefined;
        message.activationStatus = object.activationStatus ?? undefined;
        return message;
    },
};
function createBaseActivateFeatureSetRequest() {
    return { $type: "squareup.featurama.service.ActivateFeatureSetRequest", featureSetKey: undefined };
}
export const ActivateFeatureSetRequest = {
    $type: "squareup.featurama.service.ActivateFeatureSetRequest",
    encode(message, writer = __m0.Writer.create()) {
        if (message.featureSetKey !== undefined) {
            writer.uint32(8).int32(message.featureSetKey);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseActivateFeatureSetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.featureSetKey = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ActivateFeatureSetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivateFeatureSetRequest();
        message.featureSetKey = object.featureSetKey ?? undefined;
        return message;
    },
};
function createBaseDeactivateFeatureSetRequest() {
    return { $type: "squareup.featurama.service.DeactivateFeatureSetRequest", featureSetKey: undefined };
}
export const DeactivateFeatureSetRequest = {
    $type: "squareup.featurama.service.DeactivateFeatureSetRequest",
    encode(message, writer = __m0.Writer.create()) {
        if (message.featureSetKey !== undefined) {
            writer.uint32(8).int32(message.featureSetKey);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeactivateFeatureSetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.featureSetKey = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return DeactivateFeatureSetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeactivateFeatureSetRequest();
        message.featureSetKey = object.featureSetKey ?? undefined;
        return message;
    },
};
function createBaseReactivateFeatureSetRequest() {
    return { $type: "squareup.featurama.service.ReactivateFeatureSetRequest", featureSetKey: undefined };
}
export const ReactivateFeatureSetRequest = {
    $type: "squareup.featurama.service.ReactivateFeatureSetRequest",
    encode(message, writer = __m0.Writer.create()) {
        if (message.featureSetKey !== undefined) {
            writer.uint32(8).int32(message.featureSetKey);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReactivateFeatureSetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.featureSetKey = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ReactivateFeatureSetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReactivateFeatureSetRequest();
        message.featureSetKey = object.featureSetKey ?? undefined;
        return message;
    },
};
function createBaseBulkRetrieveFeatureSetStatusesResponse() {
    return { $type: "squareup.featurama.service.BulkRetrieveFeatureSetStatusesResponse", featureSetStatuses: [] };
}
export const BulkRetrieveFeatureSetStatusesResponse = {
    $type: "squareup.featurama.service.BulkRetrieveFeatureSetStatusesResponse",
    encode(message, writer = __m0.Writer.create()) {
        for (const v of message.featureSetStatuses) {
            FeatureSetStatusForSeller.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBulkRetrieveFeatureSetStatusesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.featureSetStatuses.push(FeatureSetStatusForSeller.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BulkRetrieveFeatureSetStatusesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBulkRetrieveFeatureSetStatusesResponse();
        message.featureSetStatuses = object.featureSetStatuses?.map((e) => FeatureSetStatusForSeller.fromPartial(e)) || [];
        return message;
    },
};
function createBaseBulkRetrieveFeatureStatusesResponse() {
    return { $type: "squareup.featurama.service.BulkRetrieveFeatureStatusesResponse", featureStatuses: [] };
}
export const BulkRetrieveFeatureStatusesResponse = {
    $type: "squareup.featurama.service.BulkRetrieveFeatureStatusesResponse",
    encode(message, writer = __m0.Writer.create()) {
        for (const v of message.featureStatuses) {
            FeatureStatusForSeller.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBulkRetrieveFeatureStatusesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.featureStatuses.push(FeatureStatusForSeller.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BulkRetrieveFeatureStatusesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBulkRetrieveFeatureStatusesResponse();
        message.featureStatuses = object.featureStatuses?.map((e) => FeatureStatusForSeller.fromPartial(e)) || [];
        return message;
    },
};
function createBaseRetrieveFeatureSetStatusResponse() {
    return { $type: "squareup.featurama.service.RetrieveFeatureSetStatusResponse", featureSetStatus: undefined };
}
export const RetrieveFeatureSetStatusResponse = {
    $type: "squareup.featurama.service.RetrieveFeatureSetStatusResponse",
    encode(message, writer = __m0.Writer.create()) {
        if (message.featureSetStatus !== undefined) {
            FeatureSetStatusForSeller.encode(message.featureSetStatus, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRetrieveFeatureSetStatusResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.featureSetStatus = FeatureSetStatusForSeller.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return RetrieveFeatureSetStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRetrieveFeatureSetStatusResponse();
        message.featureSetStatus = (object.featureSetStatus !== undefined && object.featureSetStatus !== null)
            ? FeatureSetStatusForSeller.fromPartial(object.featureSetStatus)
            : undefined;
        return message;
    },
};
function createBaseUpdateFeatureSetStatusResponse() {
    return {
        $type: "squareup.featurama.service.UpdateFeatureSetStatusResponse",
        activationStatus: undefined,
        statusUpdated: undefined,
    };
}
export const UpdateFeatureSetStatusResponse = {
    $type: "squareup.featurama.service.UpdateFeatureSetStatusResponse",
    encode(message, writer = __m0.Writer.create()) {
        if (message.activationStatus !== undefined) {
            writer.uint32(8).int32(message.activationStatus);
        }
        if (message.statusUpdated !== undefined) {
            writer.uint32(16).bool(message.statusUpdated);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateFeatureSetStatusResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.activationStatus = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.statusUpdated = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return UpdateFeatureSetStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateFeatureSetStatusResponse();
        message.activationStatus = object.activationStatus ?? undefined;
        message.statusUpdated = object.statusUpdated ?? undefined;
        return message;
    },
};
function createBaseActivateFeatureSetResponse() {
    return { $type: "squareup.featurama.service.ActivateFeatureSetResponse", statusUpdated: undefined };
}
export const ActivateFeatureSetResponse = {
    $type: "squareup.featurama.service.ActivateFeatureSetResponse",
    encode(message, writer = __m0.Writer.create()) {
        if (message.statusUpdated !== undefined) {
            writer.uint32(8).bool(message.statusUpdated);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseActivateFeatureSetResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.statusUpdated = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ActivateFeatureSetResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivateFeatureSetResponse();
        message.statusUpdated = object.statusUpdated ?? undefined;
        return message;
    },
};
function createBaseDeactivateFeatureSetResponse() {
    return { $type: "squareup.featurama.service.DeactivateFeatureSetResponse" };
}
export const DeactivateFeatureSetResponse = {
    $type: "squareup.featurama.service.DeactivateFeatureSetResponse",
    encode(_, writer = __m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeactivateFeatureSetResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return DeactivateFeatureSetResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDeactivateFeatureSetResponse();
        return message;
    },
};
function createBaseReactivateFeatureSetResponse() {
    return { $type: "squareup.featurama.service.ReactivateFeatureSetResponse" };
}
export const ReactivateFeatureSetResponse = {
    $type: "squareup.featurama.service.ReactivateFeatureSetResponse",
    encode(_, writer = __m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReactivateFeatureSetResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ReactivateFeatureSetResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseReactivateFeatureSetResponse();
        return message;
    },
};
function createBaseInternalBulkRetrieveFeatureSetStatusesRequest() {
    return {
        $type: "squareup.featurama.service.InternalBulkRetrieveFeatureSetStatusesRequest",
        merchantToken: undefined,
        request: undefined,
    };
}
export const InternalBulkRetrieveFeatureSetStatusesRequest = {
    $type: "squareup.featurama.service.InternalBulkRetrieveFeatureSetStatusesRequest",
    encode(message, writer = __m0.Writer.create()) {
        if (message.merchantToken !== undefined) {
            writer.uint32(10).string(message.merchantToken);
        }
        if (message.request !== undefined) {
            BulkRetrieveFeatureSetStatusesRequest.encode(message.request, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInternalBulkRetrieveFeatureSetStatusesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.merchantToken = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.request = BulkRetrieveFeatureSetStatusesRequest.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return InternalBulkRetrieveFeatureSetStatusesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInternalBulkRetrieveFeatureSetStatusesRequest();
        message.merchantToken = object.merchantToken ?? undefined;
        message.request = (object.request !== undefined && object.request !== null)
            ? BulkRetrieveFeatureSetStatusesRequest.fromPartial(object.request)
            : undefined;
        return message;
    },
};
function createBaseInternalBulkRetrieveFeatureStatusesRequest() {
    return {
        $type: "squareup.featurama.service.InternalBulkRetrieveFeatureStatusesRequest",
        merchantToken: undefined,
        request: undefined,
    };
}
export const InternalBulkRetrieveFeatureStatusesRequest = {
    $type: "squareup.featurama.service.InternalBulkRetrieveFeatureStatusesRequest",
    encode(message, writer = __m0.Writer.create()) {
        if (message.merchantToken !== undefined) {
            writer.uint32(10).string(message.merchantToken);
        }
        if (message.request !== undefined) {
            BulkRetrieveFeatureStatusesRequest.encode(message.request, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInternalBulkRetrieveFeatureStatusesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.merchantToken = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.request = BulkRetrieveFeatureStatusesRequest.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return InternalBulkRetrieveFeatureStatusesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInternalBulkRetrieveFeatureStatusesRequest();
        message.merchantToken = object.merchantToken ?? undefined;
        message.request = (object.request !== undefined && object.request !== null)
            ? BulkRetrieveFeatureStatusesRequest.fromPartial(object.request)
            : undefined;
        return message;
    },
};
function createBaseInternalBulkRetrieveFeatureSetStatusesResponse() {
    return { $type: "squareup.featurama.service.InternalBulkRetrieveFeatureSetStatusesResponse", response: undefined };
}
export const InternalBulkRetrieveFeatureSetStatusesResponse = {
    $type: "squareup.featurama.service.InternalBulkRetrieveFeatureSetStatusesResponse",
    encode(message, writer = __m0.Writer.create()) {
        if (message.response !== undefined) {
            BulkRetrieveFeatureSetStatusesResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInternalBulkRetrieveFeatureSetStatusesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.response = BulkRetrieveFeatureSetStatusesResponse.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return InternalBulkRetrieveFeatureSetStatusesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInternalBulkRetrieveFeatureSetStatusesResponse();
        message.response = (object.response !== undefined && object.response !== null)
            ? BulkRetrieveFeatureSetStatusesResponse.fromPartial(object.response)
            : undefined;
        return message;
    },
};
function createBaseInternalBulkRetrieveFeatureStatusesResponse() {
    return { $type: "squareup.featurama.service.InternalBulkRetrieveFeatureStatusesResponse", response: undefined };
}
export const InternalBulkRetrieveFeatureStatusesResponse = {
    $type: "squareup.featurama.service.InternalBulkRetrieveFeatureStatusesResponse",
    encode(message, writer = __m0.Writer.create()) {
        if (message.response !== undefined) {
            BulkRetrieveFeatureStatusesResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInternalBulkRetrieveFeatureStatusesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.response = BulkRetrieveFeatureStatusesResponse.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return InternalBulkRetrieveFeatureStatusesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInternalBulkRetrieveFeatureStatusesResponse();
        message.response = (object.response !== undefined && object.response !== null)
            ? BulkRetrieveFeatureStatusesResponse.fromPartial(object.response)
            : undefined;
        return message;
    },
};
export const FeaturamaServiceServiceName = "squareup.featurama.service.FeaturamaService";
export class FeaturamaServiceClientImpl {
    rpc;
    service;
    constructor(rpc, opts) {
        this.service = opts?.service || FeaturamaServiceServiceName;
        this.rpc = rpc;
        this.bulkRetrieveFeatureSetStatuses = this.bulkRetrieveFeatureSetStatuses.bind(this);
        this.bulkRetrieveFeatureStatuses = this.bulkRetrieveFeatureStatuses.bind(this);
        this.retrieveFeatureSetStatus = this.retrieveFeatureSetStatus.bind(this);
        this.updateFeatureSetStatus = this.updateFeatureSetStatus.bind(this);
        this.activateFeatureSet = this.activateFeatureSet.bind(this);
        this.deactivateFeatureSet = this.deactivateFeatureSet.bind(this);
        this.reactivateFeatureSet = this.reactivateFeatureSet.bind(this);
    }
    bulkRetrieveFeatureSetStatuses(request) {
        const data = BulkRetrieveFeatureSetStatusesRequest.encode(request).finish();
        if (this.rpc.beforeRequest) {
            this.rpc.beforeRequest(this.service, "BulkRetrieveFeatureSetStatuses", request);
        }
        const promise = this.rpc.request(this.service, "BulkRetrieveFeatureSetStatuses", data);
        return promise.then((data) => {
            try {
                const response = BulkRetrieveFeatureSetStatusesResponse.decode(__m0.Reader.create(data));
                if (this.rpc.afterResponse) {
                    this.rpc.afterResponse(this.service, "BulkRetrieveFeatureSetStatuses", response);
                }
                return response;
            }
            catch (error) {
                return Promise.reject(error);
            }
        }).catch((error) => {
            if (this.rpc.handleError) {
                return Promise.reject(this.rpc.handleError(this.service, "BulkRetrieveFeatureSetStatuses", error));
            }
            return Promise.reject(error);
        });
    }
    bulkRetrieveFeatureStatuses(request) {
        const data = BulkRetrieveFeatureStatusesRequest.encode(request).finish();
        if (this.rpc.beforeRequest) {
            this.rpc.beforeRequest(this.service, "BulkRetrieveFeatureStatuses", request);
        }
        const promise = this.rpc.request(this.service, "BulkRetrieveFeatureStatuses", data);
        return promise.then((data) => {
            try {
                const response = BulkRetrieveFeatureStatusesResponse.decode(__m0.Reader.create(data));
                if (this.rpc.afterResponse) {
                    this.rpc.afterResponse(this.service, "BulkRetrieveFeatureStatuses", response);
                }
                return response;
            }
            catch (error) {
                return Promise.reject(error);
            }
        }).catch((error) => {
            if (this.rpc.handleError) {
                return Promise.reject(this.rpc.handleError(this.service, "BulkRetrieveFeatureStatuses", error));
            }
            return Promise.reject(error);
        });
    }
    retrieveFeatureSetStatus(request) {
        const data = RetrieveFeatureSetStatusRequest.encode(request).finish();
        if (this.rpc.beforeRequest) {
            this.rpc.beforeRequest(this.service, "RetrieveFeatureSetStatus", request);
        }
        const promise = this.rpc.request(this.service, "RetrieveFeatureSetStatus", data);
        return promise.then((data) => {
            try {
                const response = RetrieveFeatureSetStatusResponse.decode(__m0.Reader.create(data));
                if (this.rpc.afterResponse) {
                    this.rpc.afterResponse(this.service, "RetrieveFeatureSetStatus", response);
                }
                return response;
            }
            catch (error) {
                return Promise.reject(error);
            }
        }).catch((error) => {
            if (this.rpc.handleError) {
                return Promise.reject(this.rpc.handleError(this.service, "RetrieveFeatureSetStatus", error));
            }
            return Promise.reject(error);
        });
    }
    updateFeatureSetStatus(request) {
        const data = UpdateFeatureSetStatusRequest.encode(request).finish();
        if (this.rpc.beforeRequest) {
            this.rpc.beforeRequest(this.service, "UpdateFeatureSetStatus", request);
        }
        const promise = this.rpc.request(this.service, "UpdateFeatureSetStatus", data);
        return promise.then((data) => {
            try {
                const response = UpdateFeatureSetStatusResponse.decode(__m0.Reader.create(data));
                if (this.rpc.afterResponse) {
                    this.rpc.afterResponse(this.service, "UpdateFeatureSetStatus", response);
                }
                return response;
            }
            catch (error) {
                return Promise.reject(error);
            }
        }).catch((error) => {
            if (this.rpc.handleError) {
                return Promise.reject(this.rpc.handleError(this.service, "UpdateFeatureSetStatus", error));
            }
            return Promise.reject(error);
        });
    }
    activateFeatureSet(request) {
        const data = ActivateFeatureSetRequest.encode(request).finish();
        if (this.rpc.beforeRequest) {
            this.rpc.beforeRequest(this.service, "ActivateFeatureSet", request);
        }
        const promise = this.rpc.request(this.service, "ActivateFeatureSet", data);
        return promise.then((data) => {
            try {
                const response = ActivateFeatureSetResponse.decode(__m0.Reader.create(data));
                if (this.rpc.afterResponse) {
                    this.rpc.afterResponse(this.service, "ActivateFeatureSet", response);
                }
                return response;
            }
            catch (error) {
                return Promise.reject(error);
            }
        }).catch((error) => {
            if (this.rpc.handleError) {
                return Promise.reject(this.rpc.handleError(this.service, "ActivateFeatureSet", error));
            }
            return Promise.reject(error);
        });
    }
    deactivateFeatureSet(request) {
        const data = DeactivateFeatureSetRequest.encode(request).finish();
        if (this.rpc.beforeRequest) {
            this.rpc.beforeRequest(this.service, "DeactivateFeatureSet", request);
        }
        const promise = this.rpc.request(this.service, "DeactivateFeatureSet", data);
        return promise.then((data) => {
            try {
                const response = DeactivateFeatureSetResponse.decode(__m0.Reader.create(data));
                if (this.rpc.afterResponse) {
                    this.rpc.afterResponse(this.service, "DeactivateFeatureSet", response);
                }
                return response;
            }
            catch (error) {
                return Promise.reject(error);
            }
        }).catch((error) => {
            if (this.rpc.handleError) {
                return Promise.reject(this.rpc.handleError(this.service, "DeactivateFeatureSet", error));
            }
            return Promise.reject(error);
        });
    }
    reactivateFeatureSet(request) {
        const data = ReactivateFeatureSetRequest.encode(request).finish();
        if (this.rpc.beforeRequest) {
            this.rpc.beforeRequest(this.service, "ReactivateFeatureSet", request);
        }
        const promise = this.rpc.request(this.service, "ReactivateFeatureSet", data);
        return promise.then((data) => {
            try {
                const response = ReactivateFeatureSetResponse.decode(__m0.Reader.create(data));
                if (this.rpc.afterResponse) {
                    this.rpc.afterResponse(this.service, "ReactivateFeatureSet", response);
                }
                return response;
            }
            catch (error) {
                return Promise.reject(error);
            }
        }).catch((error) => {
            if (this.rpc.handleError) {
                return Promise.reject(this.rpc.handleError(this.service, "ReactivateFeatureSet", error));
            }
            return Promise.reject(error);
        });
    }
}
export const FeaturamaServiceDefinition = {
    name: "FeaturamaService",
    fullName: "squareup.featurama.service.FeaturamaService",
    methods: {
        bulkRetrieveFeatureSetStatuses: {
            name: "BulkRetrieveFeatureSetStatuses",
            requestType: BulkRetrieveFeatureSetStatusesRequest,
            requestStream: false,
            responseType: BulkRetrieveFeatureSetStatusesResponse,
            responseStream: false,
            options: { _unknownFields: { 184000: [new Uint8Array([1])] } },
        },
        bulkRetrieveFeatureStatuses: {
            name: "BulkRetrieveFeatureStatuses",
            requestType: BulkRetrieveFeatureStatusesRequest,
            requestStream: false,
            responseType: BulkRetrieveFeatureStatusesResponse,
            responseStream: false,
            options: { _unknownFields: { 184000: [new Uint8Array([1])] } },
        },
        retrieveFeatureSetStatus: {
            name: "RetrieveFeatureSetStatus",
            requestType: RetrieveFeatureSetStatusRequest,
            requestStream: false,
            responseType: RetrieveFeatureSetStatusResponse,
            responseStream: false,
            options: { _unknownFields: { 184000: [new Uint8Array([1])] } },
        },
        updateFeatureSetStatus: {
            name: "UpdateFeatureSetStatus",
            requestType: UpdateFeatureSetStatusRequest,
            requestStream: false,
            responseType: UpdateFeatureSetStatusResponse,
            responseStream: false,
            options: { _unknownFields: { 184000: [new Uint8Array([1])] } },
        },
        activateFeatureSet: {
            name: "ActivateFeatureSet",
            requestType: ActivateFeatureSetRequest,
            requestStream: false,
            responseType: ActivateFeatureSetResponse,
            responseStream: false,
            options: { _unknownFields: { 184000: [new Uint8Array([1])] } },
        },
        deactivateFeatureSet: {
            name: "DeactivateFeatureSet",
            requestType: DeactivateFeatureSetRequest,
            requestStream: false,
            responseType: DeactivateFeatureSetResponse,
            responseStream: false,
            options: { _unknownFields: { 184000: [new Uint8Array([1])] } },
        },
        reactivateFeatureSet: {
            name: "ReactivateFeatureSet",
            requestType: ReactivateFeatureSetRequest,
            requestStream: false,
            responseType: ReactivateFeatureSetResponse,
            responseStream: false,
            options: { _unknownFields: { 184000: [new Uint8Array([1])] } },
        },
    },
};
export const InternalFeaturamaServiceServiceName = "squareup.featurama.service.InternalFeaturamaService";
export class InternalFeaturamaServiceClientImpl {
    rpc;
    service;
    constructor(rpc, opts) {
        this.service = opts?.service || InternalFeaturamaServiceServiceName;
        this.rpc = rpc;
        this.internalBulkRetrieveFeatureSetStatuses = this.internalBulkRetrieveFeatureSetStatuses.bind(this);
        this.internalBulkRetrieveFeatureStatuses = this.internalBulkRetrieveFeatureStatuses.bind(this);
    }
    internalBulkRetrieveFeatureSetStatuses(request) {
        const data = InternalBulkRetrieveFeatureSetStatusesRequest.encode(request).finish();
        if (this.rpc.beforeRequest) {
            this.rpc.beforeRequest(this.service, "InternalBulkRetrieveFeatureSetStatuses", request);
        }
        const promise = this.rpc.request(this.service, "InternalBulkRetrieveFeatureSetStatuses", data);
        return promise.then((data) => {
            try {
                const response = InternalBulkRetrieveFeatureSetStatusesResponse.decode(__m0.Reader.create(data));
                if (this.rpc.afterResponse) {
                    this.rpc.afterResponse(this.service, "InternalBulkRetrieveFeatureSetStatuses", response);
                }
                return response;
            }
            catch (error) {
                return Promise.reject(error);
            }
        }).catch((error) => {
            if (this.rpc.handleError) {
                return Promise.reject(this.rpc.handleError(this.service, "InternalBulkRetrieveFeatureSetStatuses", error));
            }
            return Promise.reject(error);
        });
    }
    internalBulkRetrieveFeatureStatuses(request) {
        const data = InternalBulkRetrieveFeatureStatusesRequest.encode(request).finish();
        if (this.rpc.beforeRequest) {
            this.rpc.beforeRequest(this.service, "InternalBulkRetrieveFeatureStatuses", request);
        }
        const promise = this.rpc.request(this.service, "InternalBulkRetrieveFeatureStatuses", data);
        return promise.then((data) => {
            try {
                const response = InternalBulkRetrieveFeatureStatusesResponse.decode(__m0.Reader.create(data));
                if (this.rpc.afterResponse) {
                    this.rpc.afterResponse(this.service, "InternalBulkRetrieveFeatureStatuses", response);
                }
                return response;
            }
            catch (error) {
                return Promise.reject(error);
            }
        }).catch((error) => {
            if (this.rpc.handleError) {
                return Promise.reject(this.rpc.handleError(this.service, "InternalBulkRetrieveFeatureStatuses", error));
            }
            return Promise.reject(error);
        });
    }
}
export const InternalFeaturamaServiceDefinition = {
    name: "InternalFeaturamaService",
    fullName: "squareup.featurama.service.InternalFeaturamaService",
    methods: {
        internalBulkRetrieveFeatureSetStatuses: {
            name: "InternalBulkRetrieveFeatureSetStatuses",
            requestType: InternalBulkRetrieveFeatureSetStatusesRequest,
            requestStream: false,
            responseType: InternalBulkRetrieveFeatureSetStatusesResponse,
            responseStream: false,
            options: {},
        },
        internalBulkRetrieveFeatureStatuses: {
            name: "InternalBulkRetrieveFeatureStatuses",
            requestType: InternalBulkRetrieveFeatureStatusesRequest,
            requestStream: false,
            responseType: InternalBulkRetrieveFeatureStatusesResponse,
            responseStream: false,
            options: {},
        },
    },
};
